(function($) {
  $(document).on('product.skuSelect', '.js-product-ui', function(e, skuBaseId) {
    var $product = $(this);
    $product.data('sku-base-id', skuBaseId);
  });
})(jQuery);
